import {
  BUSINESS_PREFERENCES,
  PRIVAT_PREFERENCES,
  type State,
} from "@/features/quote/shared/quote-config";
import type { UtmParams } from "@/shared/analytics/useUtmParams";
import { toE164 } from "@/shared/lib/phone";

// Pure transformation of wizard state → /api/lead request body. No validation
// or side effects - the caller validates email/phone before calling this.
export function buildLeadPayload(
  state: State,
  utmParams: UtmParams,
  eventId: string,
  honeypot: string,
  isRepeatTask: boolean,
) {
  const taskType = state.audience === "privat" ? state.task : state.businessTask;
  const business = state.audience === "erhverv" ? state.business : null;
  const engangsSubtype =
    state.audience === "privat" && state.task === "engangs" && state.engangsSubtype
      ? state.engangsSubtype
      : state.audience === "erhverv" && state.businessTask === "engangs" && state.engangsSubtype
        ? state.engangsSubtype
        : null;
  const recurring = taskType === "lobende";

  const engangsAndetDescription =
    state.audience === "erhverv" &&
    state.businessTask === "engangs" &&
    state.engangsSubtype === "andet" &&
    state.engangsAndetDescription.trim()
      ? state.engangsAndetDescription.trim()
      : null;
  const notes = state.notes.trim() || null;

  // Map values → labels for GHL-friendly comma strings
  const prefList = state.audience === "privat" ? PRIVAT_PREFERENCES : BUSINESS_PREFERENCES;
  const preferencesLabels = state.preferences
    .map((v) => prefList.find((p) => p.value === v)?.label)
    .filter((l): l is string => Boolean(l))
    .join(", ");

  return {
    // Honeypot: must be in the payload so the route can see it. Empty = human;
    // filled = bot, and /api/lead silently drops the submission.
    ref_token: honeypot,
    clientType: state.audience,
    taskType,
    business,
    propertyType: state.audience === "privat" ? state.propertyType || null : null,
    floor:
      state.audience === "privat" && state.propertyType === "lejlighed" && state.floor
        ? state.floor
        : null,
    postalCode: state.postalCode || null,
    adgangsadresseId: state.address?.adresse.id || null,
    streetAddress: state.streetAddress || null,
    engangsSubtype,
    engangsAndetDescription,
    recurring,
    frequency: state.frequency || null,
    preferences: state.preferences,
    preferencesLabels,
    priority: state.priority || null,
    squareMeters: state.squareMeters ? Number.parseInt(state.squareMeters, 10) : null,
    startTiming: state.startTiming || null,
    startDate: state.startTiming === "SPECIFIK_DATO" ? state.startDate || null : null,
    timeSlots: state.timeSlots,
    callTimes: state.callTimes,
    contactName: state.contactName.trim(),
    companyName: state.companyName.trim() || null,
    email: state.email.trim(),
    phone: toE164(state.phone),
    notes,
    consent: state.consent,
    isRepeatTask,
    ...utmParams,
    eventId,
  };
}
